import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';

import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
var render = function render() {
  var _vm$stock$reference_w;
  var _vm = this,
    _c = _vm._self._c;
  return _c(VDialog, {
    attrs: {
      persistent: "",
      "max-width": _vm.items.length ? "100%" : 950
    },
    model: {
      value: _vm.shown,
      callback: function callback($$v) {
        _vm.shown = $$v;
      },
      expression: "shown"
    }
  }, [_c(VCard, [_c("div", {
    staticClass: "dialog-closer"
  }, [_c(VIcon, {
    staticClass: "far fa-times-circle",
    on: {
      click: _vm.close
    }
  })], 1), _c(VCardTitle, [_c("div", {
    staticClass: "text-h5"
  }, [_vm._v("Committed stocks")])]), _c(VCardText, [!_vm.loaded ? _c(VSkeletonLoader, {
    attrs: {
      width: "100%",
      type: "list-item-two-line"
    }
  }) : _c("div", {
    staticClass: "pt-0"
  }, [_c("div", {
    staticClass: "mb-3"
  }, [_c("div", [_vm._v(" " + _vm._s(_vm.stock.wine.display_name) + " ")]), _c("div", [_vm._v(" " + _vm._s((_vm$stock$reference_w = _vm.stock.reference_warehouse) !== null && _vm$stock$reference_w !== void 0 ? _vm$stock$reference_w : _vm.stock.wine.accountancy_code) + " : "), _vm.stock.stock_type.toLowerCase() == "stock" ? [_vm._v(" " + _vm._s(_vm.stock.warehouse.name) + " ")] : _vm.stock.stock_type.toLowerCase() == "consignment" ? [_vm._v(" Direct Producer ")] : _vm._e()], 2)]), _c(VDataTable, {
    staticClass: "elevation-2 cursor--pointer",
    attrs: {
      id: "table",
      headers: _vm.headers,
      items: _vm.items,
      "loading-text": "Loading... Please wait",
      "hide-default-footer": "",
      "disable-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "item.order.user.full_name",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_vm._v(" " + _vm._s(_vm.getFullNameUser(item.order.user)) + " ")];
      }
    }, {
      key: "item.order.date_order",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_vm._v(" " + _vm._s(new Intl.DateTimeFormat("en-GB", {
          dateStyle: "full"
        }).format(new Date(item.order.date_order))) + " ")];
      }
    }, {
      key: "item.order.status",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_vm._v(" " + _vm._s(_vm.orderStatus.find(function (x) {
          return x.status == item.order.status;
        }).value) + " ")];
      }
    }, {
      key: "item.actions",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return [item.order.status !== _vm.orderStatus.filter(function (os) {
          return os.id === "CREATED";
        })[0].status ? _c(VBtn, {
          staticClass: "dfwa-btn --small-2",
          attrs: {
            rounded: true,
            to: _vm.orderRoute(item.order.id_order)
          }
        }, [_vm._v(" Order details ")]) : _vm._e()];
      }
    }], null, true)
  })], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };